import CloseIcon from '@mui/icons-material/Close';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import {AppBar, Box, Dialog, IconButton, Toolbar, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import AgentChatPanel from './AgentChatPanel';

type AgentChatDialogProps = {
  open: boolean;
  onClose: () => void;
  panelKey?: string;
};

const AgentChatDialog = ({open, onClose, panelKey}: AgentChatDialogProps) => {
  const {t} = useTranslation();

  return (
    <Dialog fullScreen open={open} onClose={onClose} keepMounted>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar variant="dense">
          <SmartToyIcon fontSize="small" sx={{mr: 1}} />
          <Typography variant="subtitle1" sx={{flex: 1}}>
            {t('AI Agent')}
          </Typography>
          <IconButton edge="end" aria-label={t('閉じる')} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{height: 'calc(100vh - 48px)', p: 1, overflow: 'hidden'}}>
        <AgentChatPanel key={panelKey || 'agent'} />
      </Box>
    </Dialog>
  );
};

export default AgentChatDialog;
